import { render, staticRenderFns } from "./ProductCollectionDialog.vue?vue&type=template&id=5782d347"
import script from "./ProductCollectionDialog.vue?vue&type=script&lang=ts"
export * from "./ProductCollectionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports